/* SEKO : comportements du formulaire de commande (Releasit). Fichier charge sur tout le site. */
(function () {
  var SEL = '[id*="_rsi"],[class*="_rsi"]';
  // Une case a cocher (mot-cle c) fait apparaitre un champ (mots-cles f)
  var DEFS = [
    { c: 'carte', f: ['mot', 'carte'] },
    { c: 'offrir', f: ['reçoit'] }
  ];
  // La case "c'est pour offrir" commande l'affichage des options cadeau
  var MAITRE = 'offrir';
  var OPTIONS = ['sac cadeau', 'ruban', 'carte'];
  var TRAD = {
    'this field is required.': 'Ce champ est nécessaire.',
    'this field is required': 'Ce champ est nécessaire.'
  };
  var etat = { maitre: null, options: [] };

  function txt(el) { return (el && el.textContent ? el.textContent : '').toLowerCase(); }

  function bloc(f) {
    var w = f;
    while (w.parentElement && w.parentElement.querySelectorAll('input,textarea,select').length === 1 && w.parentElement.closest(SEL)) { w = w.parentElement; }
    return w;
  }

  function boite(k) {
    var b = k;
    while (b.parentElement && b.parentElement.closest(SEL) && b.parentElement.querySelectorAll('input[type=checkbox]').length === 1 && b.parentElement.querySelectorAll('input[type=text],input[type=tel],textarea,input[type=radio]').length === 0) { b = b.parentElement; }
    return b;
  }

  // Bandeau "voir nos autres modeles" sous l'en-tete du pop-up
  function lien() {
    var list = document.querySelectorAll('[id*="_rsi"] [class*="close"], [class*="_rsi"] [class*="close"]');
    for (var i = 0; i < list.length; i++) {
      var h = list[i].parentElement;
      if (!h || !h.parentElement) continue;
      if (h.parentElement.querySelector('.seko-continue')) continue;
      if (!h.parentElement.querySelector('input')) continue;
      var a = document.createElement('a');
      a.className = 'seko-continue';
      a.href = '/';
      a.textContent = 'Vous n’avez pas fini ? Voir nos autres modèles';
      h.insertAdjacentElement('afterend', a);
    }
  }

  // Options cadeau visibles seulement si "c'est pour offrir" est coche
  function cadeaux() {
    etat.maitre = null;
    etat.options = [];
    var cases = document.querySelectorAll('input[type=checkbox]');
    for (var i = 0; i < cases.length; i++) {
      var k = cases[i];
      if (!k.closest(SEL)) continue;
      var t = txt(boite(k));
      if (t.indexOf(MAITRE) !== -1) { etat.maitre = k; continue; }
      for (var o = 0; o < OPTIONS.length; o++) {
        if (t.indexOf(OPTIONS[o]) !== -1) { etat.options.push(k); break; }
      }
    }
    if (!etat.maitre) return;
    boite(etat.maitre).classList.add('seko-maitre');
    var ouvert = etat.maitre.checked;
    for (var j = 0; j < etat.options.length; j++) {
      var opt = etat.options[j];
      boite(opt).style.display = ouvert ? '' : 'none';
      // Une option cachee ne doit jamais rester cochee : la cliente paierait sans le voir
      if (!ouvert && opt.checked) { try { opt.click(); } catch (e) {} }
    }
  }

  // Ordre d'affichage sur mobile, sans deplacer le code de l'application
  function ranger(res) {
    if (!window.matchMedia || !window.matchMedia('(max-width: 699px)').matches) return;
    var elements = [];
    for (var r = 0; r < res.length; r++) { elements.push(res[r].w); elements.push(res[r].b); }
    if (etat.maitre) { elements.push(boite(etat.maitre)); }
    for (var e = 0; e < etat.options.length; e++) { elements.push(boite(etat.options[e])); }
    function tous(a) { for (var i = 0; i < elements.length; i++) { if (!a.contains(elements[i])) return false; } return true; }
    var A = elements[0].parentElement;
    while (A && !tous(A)) { A = A.parentElement; }
    if (!A || !A.closest(SEL)) return;
    for (var i = 0; i < elements.length; i++) {
      var p = elements[i].parentElement;
      while (p && p !== A) { p.style.display = 'contents'; p = p.parentElement; }
    }
    A.style.display = 'flex';
    A.style.flexDirection = 'column';
    var liste = [];
    (function marche(n) {
      for (var c = n.firstElementChild; c; c = c.nextElementSibling) {
        if (c.style && c.style.display === 'contents') { marche(c); } else { liste.push(c); }
      }
    })(A);
    for (var m = 0; m < liste.length; m++) { liste[m].style.order = String(m * 10); }
    // "C'est pour offrir" passe avant la premiere option cadeau
    if (etat.maitre && etat.options.length) {
      var min = null;
      for (var x = 0; x < etat.options.length; x++) {
        var v = parseInt(boite(etat.options[x]).style.order || '0', 10);
        if (min === null || v < min) { min = v; }
      }
      boite(etat.maitre).style.order = String(min - 8);
    }
    // Chaque champ lie se place juste sous sa case
    for (var q = 0; q < res.length; q++) {
      var o = parseInt(res[q].b.style.order || '0', 10);
      res[q].w.style.order = String(o + 3);
    }
  }

  function champsLies() {
    var champs = document.querySelectorAll('input[type=text],textarea');
    var res = [];
    for (var i = 0; i < champs.length; i++) {
      var f = champs[i];
      if (!f.closest(SEL)) continue;
      var w = bloc(f);
      var libelle = txt(w) + ' ' + (f.getAttribute('placeholder') || '').toLowerCase();
      for (var d = 0; d < DEFS.length; d++) {
        var ok = true;
        for (var x = 0; x < DEFS[d].f.length; x++) { if (libelle.indexOf(DEFS[d].f[x]) === -1) { ok = false; } }
        if (!ok) continue;
        var racine = f.closest('form') || document;
        var cases = racine.querySelectorAll('input[type=checkbox]');
        var trouve = null;
        for (var j = 0; j < cases.length; j++) {
          var k = cases[j];
          if (!k.closest(SEL)) continue;
          if (txt(boite(k)).indexOf(DEFS[d].c) !== -1) { trouve = k; break; }
        }
        if (!trouve) continue;
        w.style.display = trouve.checked ? '' : 'none';
        res.push({ w: w, b: boite(trouve) });
        break;
      }
    }
    if (res.length) { try { ranger(res); } catch (e) {} }
  }

  // Messages de l'application restes en anglais
  function traduire() {
    var els = document.querySelectorAll('[id*="_rsi"] *, [class*="_rsi"] *');
    for (var i = 0; i < els.length; i++) {
      var e = els[i];
      if (e.children.length) continue;
      var v = (e.textContent || '').trim().toLowerCase();
      if (TRAD[v]) { e.textContent = TRAD[v]; }
    }
  }

  // Champs obligatoires encore vides
  function manquants() {
    var out = [];
    var ins = document.querySelectorAll('input[type=text],input[type=tel],input[type=email],textarea,select');
    for (var i = 0; i < ins.length; i++) {
      var f = ins[i];
      if (!f.closest(SEL)) continue;
      if (f.offsetParent === null) continue;
      var w = bloc(f);
      var lab = w.querySelector('label');
      var nom = ((lab ? lab.textContent : w.textContent) || '');
      var req = f.required || f.getAttribute('aria-required') === 'true' || nom.indexOf('*') !== -1;
      if (!req) continue;
      if (((f.value || '') + '').trim() === '') {
        out.push({ nom: nom.split('*').join('').trim(), el: f });
      }
    }
    return out;
  }

  function surConfirmer(e) {
    var cible = e.target && e.target.closest ? e.target.closest('button[type=submit],[class*="submit"]') : null;
    if (!cible || !cible.closest(SEL)) return;
    var m = manquants();
    var msg = document.querySelector('.seko-manque');
    if (!m.length) { if (msg) { msg.remove(); } return; }
    if (!msg) {
      msg = document.createElement('div');
      msg.className = 'seko-manque';
      msg.setAttribute('role', 'alert');
    }
    var noms = [];
    for (var i = 0; i < m.length; i++) { if (m[i].nom) { noms.push(m[i].nom); } }
    msg.textContent = 'Pour confirmer, il reste à remplir : ' + noms.join(', ') + '.';
    if (cible.parentElement) { cible.parentElement.insertBefore(msg, cible); }
    try { m[0].el.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (err) {}
  }

  function tout() {
    try {
      lien();
      cadeaux();
      champsLies();
      traduire();
      var m = document.querySelector('.seko-manque');
      if (m && !manquants().length) { m.remove(); }
    } catch (e) {}
  }

  var t;
  try {
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(tout, 200); }).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
  document.addEventListener('change', function () { setTimeout(tout, 50); }, true);
  document.addEventListener('input', function () { clearTimeout(t); t = setTimeout(tout, 300); }, true);
  document.addEventListener('click', function (e) { try { surConfirmer(e); } catch (err) {} setTimeout(tout, 80); }, true);
  tout();
})();
